import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/credentialNotificationSettings`;

export const ROUTE: RouteDefinition = `${baseRoute}/credentialNotificationSettings`;

export const URL = (): RouteDefinition => `${baseRoute}/credentialNotificationSettings`;
